import { useEffect, useState } from "react"
import FieldInput from "src/libs/scalars"
import { SCALAR_TYPES, VerticalType } from "src/libs/scalars/interface/IScalarForm"
import { __ } from "src/libs/utilities"
import { PETestQuestionAnswer } from "../../data/interfaces"

 
export interface IRangeAnswerProps {
    item: PETestQuestionAnswer
    onChange: ( value: any, field: string, data: any ) => void
}
const RangeAnswer = (props: IRangeAnswerProps): JSX.Element => {
    const [item, setItem] = useState<PETestQuestionAnswer>(props.item as PETestQuestionAnswer)
    useEffect(() => {
        setItem(props.item)
    }, [props.item])
    
    const onChange = (value: any, field: string, data: any) => {
        props.onChange(value, field, data )
    } 

    return item.id
        ?
        <div className="my-1 py-1 w-100 border-bottom border-secondary"> 
            <FieldInput
                editable
                vertical={VerticalType.VERTICAL}
                type={SCALAR_TYPES.MEDIA}
                field="thumbnail"
                placeholder={__("Thumbnail")}
                value={ item.thumbnail}
                notClear
                isURLHide
                width={300}
                height={200}
                onChange={onChange}
            />
            <FieldInput
                editable
                vertical={VerticalType.VERTICAL} 
                placeholder={__("Title")}
                value={ item.title}
                field="title"
                className={"form-control input dark w-100 lead"}
                notClear
                onChange={onChange}
            />
            <FieldInput
                editable
                vertical={VerticalType.VERTICAL}
                placeholder={__("Answer description")}
                value={ item.post_content}
                field="post_content"
                type={SCALAR_TYPES.HTML}
                notClear
                onChange={onChange}
            />  
            <FieldInput
                editable
                vertical={ VerticalType.VERTICAL }
                field="pe_test_category"
                component="PETestCategory"
                placeholder={__("Select test category")}
                value={ !!item.pe_test_category?.length ? item.pe_test_category[0]: "" }
                type={ SCALAR_TYPES.EXTERNAL_TAGS }
                // multiple 
                origin={ item }
                notClear
                onChange={ (value, field) => onChange( [ value ], field, null ) }
            /> 
        </div>
        :
        <></>
}
export default RangeAnswer